module.exports = __webpack_public_path__ + "media/f_3.004da9fe.mp3";